import { UnansweredSafetyQuestionsTabQuery_unansweredSafetyQuestions } from '../../../graphql/__generated__/UnansweredSafetyQuestionsTabQuery'

interface Props {
  unansweredSafetyQuestion: UnansweredSafetyQuestionsTabQuery_unansweredSafetyQuestions
}

export const Position = ({ unansweredSafetyQuestion }: Props) => {
  return <>{unansweredSafetyQuestion.name}</>
}
